import {Component, OnInit} from '@angular/core';

/**
 * Bigpuntos
 * center
 * Pantalla sirve para mostrar el footer de las paginas
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
